import { render, staticRenderFns } from "./Top-Entitlements-Dynamic-Group.vue?vue&type=template&id=1264f371"
import script from "./Top-Entitlements-Dynamic-Group.vue?vue&type=script&lang=js"
export * from "./Top-Entitlements-Dynamic-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports